module.exports = __webpack_public_path__ + "img/echno_hv_Full.c18c9426.png";